import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm';
import { onDocumentReady } from "../utils/dom";
import pswpModule from "../../node_modules/photoswipe/dist/photoswipe.esm";
import 'photoswipe/style.css';

function initGallery() {
    const backEasing = {
        in: 'cubic-bezier(0.6, -0.28, 0.7, 1)',
        out: 'cubic-bezier(0.3, 0, 0.32, 1.275)',
        inOut: 'cubic-bezier(0.6, -0.28, 0.7, 1)'
      };
    const lightbox = new PhotoSwipeLightbox({
        gallery: "#gallery",
        children: "figure",
        loop: true,
        showAnimationDuration: 300,
        hideAnimationDuration: 0,
        preload: [1, 4],
        pswpModule: () => pswpModule,
    });

    lightbox.on('firstUpdate', () => {
        lightbox.pswp.options.easing = backEasing.out;
    });
    lightbox.on('initialZoomInEnd', () => {
        lightbox.pswp.options.easing = backEasing.inOut;
    });
    lightbox.on('close', () => {
        lightbox.pswp.options.easing = backEasing.in;
    });

    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'minus-button',
            ariaLabel: 'Zoom Out',
            order: 9,
            isButton: true,
            html: '-',
            onClick: (event, el) => {
                // lightbox.pswp.zoomTo(lightbox.pswp.getZoomLevel() + 0.04)
                lightbox.pswp.zoomTo(-1, {x: 0, y: 0}, 1000, false)
            }
        });
    });

    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'plus-button',
            ariaLabel: 'Zoom In',
            order: 9,
            isButton: true,
            html: '+',
            onClick: (event, el) => {
                // lightbox.pswp.toggleZoom();
                // lightbox.pswp.zoomTo(lightbox.pswp.getZoomLevel() - 0.04)
                lightbox.pswp.zoomTo(1, {x: 0, y: 0}, 1000, false)
            }
        });
    });

    lightbox.init();
}

onDocumentReady(initGallery);
